<template>
  <div class="first-section-container">

    <!-- CARDS (LEFT ON DESKTOP) -->
    <v-sheet class="cards-container pa-2">

      <welcome-text-container
        @nextStep="componentStep = 2"
        v-if="componentStep === 1"
      />

      <div 
        class="cards-wrapper" 
        ref="cardsWrapper" 
        v-show="componentStep === 2"
      >
        <div class="cards-track" ref="cardsTrack">
          <kuhul-card-product
            v-for="(card, index) in cards"
            :key="index"
            :ref="'card' + index"
            :project="card"
            class="stack-card"
            @buyNow="$emit('buyNow')"
          />
        </div>
      </div>

    </v-sheet>

    <!-- 3D (RIGHT ON DESKTOP) -->
    <v-sheet class="second-3d pa-2">
      <kuhul-3D-component 
        :id="'2'" 
        :link3d="'/models/canette-2-perfect.fbx'" 
      />
    </v-sheet>

  </div>
</template>

<script>
import WelcomeTextContainer from "./WelcomeTextContainer";
import HeadComponent from "./HeadComponent";
import Kuhul3DComponent from "./Kuhul3DComponent.vue";
import NewsCard from "./NewsCard.vue";
import KuhulCardProduct from "./KuhulCardProduct.vue";

export default {
  name: "SecondSectionKuhul",
  components: {
    WelcomeTextContainer,
    HeadComponent,
    KuhulCardProduct,
    NewsCard,
    Kuhul3DComponent,
  },

  data: () => ({
    componentStep: 2,
    cards: [
      {
        title: "Kuhul Sarab",
        description:
          "Sarab (“mirage” in Arabic) is brewed with a massive oat bill for a silky, full body. Double dry-hopped with Citra, Galaxy, and Rakau, it bursts with resinous pine, peach, and melon.",
        link:
          "https://www.bieresgourmet.be/fr/double-imperial-ipa/6447-kuhul-sarab.html",
        bgColor: `#d99990`,
        backgroundImageUrl: `/models/IMG_0320.JPG`,
        priceItems: [
          { number: 12, price: 52 },
          { number: 24, price: 100 },
        ],
      },
    ],
  }),
};
</script>

<style scoped>

/* ===== LAYOUT ===== */
.first-section-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

/* ===== CARDS ===== */
.cards-container {
  background-color: black !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
}

/* ===== 3D ===== */


.second-3d {
  flex: 0 0 40%;
  height:800px;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  position: relative;
  overflow: hidden;
}
/* ===== CARDS UI ===== */
.cards-wrapper {
  position: relative;
  height: 600px;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
}

.cards-track {
  display: flex;

  justify-content: center;
  align-items: flex-start;
  transition: transform 0.5s ease;
}

.stack-card {
  min-width: 300px;
  flex-shrink: 0;
  margin-left: -200px;
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.stack-card:first-child {
  margin-left: 0;
}

/* ===== TABLET ===== */
@media (max-width: 1264px) {
  .cards-container {
    width: 50%;
  }

  .second-3d {
    width: 50%;
    height: 600px;
  }
}

/* ===== MOBILE ===== */
@media (max-width: 960px) {
  .first-section-container {
    flex-direction: column-reverse; /* 👈 important difference */
  }

  .cards-container {
    width: 100%;
    padding: 10px;
  }

  .second-3d {
    background: black;
    width: 100vw !important;
    height: 70vh !important;
    flex: none !important;
  }

  .cards-wrapper {
    height: auto;
    overflow: visible;
  }

  .cards-track {
    flex-direction: column;
    align-items: center;
  }

  .stack-card {
    margin-left: 0;
    margin-bottom: 20px;
    width: 90%;
  }
}

</style>